import { render, staticRenderFns } from "./agency-submission.component.vue?vue&type=template&id=ea438c20&"
import script from "./agency-submission.component.ts?vue&type=script&lang=ts&"
export * from "./agency-submission.component.ts?vue&type=script&lang=ts&"
import style0 from "./agency-submission.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports